// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"574d9d57","977":"01172a94"}[chunkId] + ".chunk.js";
};